import React, { useRef, useState, useEffect } from "react";
import ActionBar from "../../common/ActionBar";
import _ from "lodash";
import labels from "../../../helpers/labels.json";
import { Padding } from "../MyParties";
import { useSnackbar } from "notistack";
import queryString from "query-string";
import { Bold } from "../../common/PartyTable";
import {
  getErrorMessage,
  parseTimeStamp,
} from "../../../helpers/functions";
import CustomTable from "../../common/CustomTable/CustomTable";
import moment from "moment";
import { navigate } from "@reach/router";
import MeetingService from "../../../services/MeetingService";

async function getParties(query = "", status) {
  try {
    const response = await MeetingService.communicationTemplates(query);
    let stats = {
      allCount:
        status !== "SMS" && status !== "whatsapp" && status !== "email"
          ? response?.data.total
          : 0,
      smsCount: status === "SMS" ? response?.data.total : 0,
      whatsappCount: status === "whatsapp" ? response?.data.total : 0,
      emailCount: status === "email" ? response?.data.total : 0,
    };
    return { ...response.data, stats };
  } catch (error) {
    throw error;
  }
}

const filterByStatus = (selectedFilter) => {
  let key = "";
  switch (selectedFilter) {
    case "SMS":
      key = "SMS";
      break;
    case "WhatsApp":
      key = "whatsapp";
      break;
    case "Email":
      key = "email";
      break;
    default:
      break;
  }
  return key;
};

const initState = [
  { label: labels["filters.all"], key: "allCount" },
  { label: "SMS", key: "smsCount" },
  { label: "WhatsApp", key: "whatsappCount" },
  { label: "Email", key: "emailCount" },
];

const Index = () => {
  const breadcrumbs = [_.startCase(labels.comms_manager)];
  const [state, setState] = useState();
  const MTRef = useRef();
  const [filters, setFilters] = useState(initState);
  const { enqueueSnackbar } = useSnackbar();
  const [selectedFilter, setSelectedFilter] = useState();

  const actions = [
    {
      text: "Communication",
      props: {
        onClick: () =>
          navigate(`/dashboard/case-manager/comms-manager/communication`),
      },
    },
  ];

  useEffect(() => {
    if (selectedFilter && MTRef?.current?.onQueryChange) {
      MTRef.current.onQueryChange({
        ...MTRef.current.state.query,
        page: 0,
      });
    }
  }, [selectedFilter]);

  function setStats(stats) {
    const mapped = initState.map((filter) => {
      let returnData = {
        label: filter.label,
      };
      if (stats[filter.key] >= 0) {
        returnData.value = stats[filter.key];
      }
      return returnData;
    });
    setFilters(mapped);
  }

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        channel: filterByStatus(selectedFilter),
        perPage: 10,
        search: query.search,
      };
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getParties(stringParams, params.channel)
        .then((result) => {
          if (result) {
            console.log(result, "result");
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
            setStats(result.stats);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  const columns = [
    {
      field: "templateName",
      title: "Template Name",
      render: (rowData) => rowData.templateName,
      headerStyle: {
        paddingLeft: 35,
      },
    },
    {
      field: "channel",
      title: "Channel",
      render: (rowData) => <Bold>{rowData.channel}</Bold>,
    },
    {
      field: "status",
      title: labels["table.status"],
      sorting: false,
      render: (rowData) => rowData.status,
    },
    {
      field: "created_at",
      tooltip: "Party Created Date",
      title: labels["table.created"],
      render: (rowData) => (
        <>
          {rowData?.submittedOn
            ? moment(rowData.submittedOn).format("DD/MM/YYYY")
            : moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}
        </>
      ),
    },
  ];

  return (
    <div>
      <ActionBar {...{ breadcrumbs, actions }} />
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage <= 1}
          pageSize={state?.data?.length ? state?.data?.length : 10}
          pluralTitle="Templates"
          placeholderText="Search Templates"
          singularTitle=""
          {...{
            columns,
            data,
            filters,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          state={state}
        />
      </Padding>
    </div>
  );
};

export default Index;
